export const extractValuesByKeys = <K extends string, T extends Record<K, unknown>>(
  sourceObject: T,
  targetKeys?: K[],
) => {
  if (!targetKeys) {
    return Object.values(sourceObject) as T[keyof T][];
  }

  return targetKeys
    .filter((key) => sourceObject.hasOwnProperty(key))
    .map((key) => sourceObject[key]);
};
